import React, { FC, useContext } from "react";

import { EditableSection } from "@/components/EditableSection";
import { Section } from "@/components/Section";
import { UserContext } from "@/components/User";
import { IConsultantProfile } from "@/data/consultant-profiles";

import { SettingsSection } from "./SettingsSection";

interface IEditableSettingsSectionProps {
  isAdmin: boolean;
  isManager: boolean;
  isOwner: boolean;
  record: IConsultantProfile;
  onUpdate?: (profile: IConsultantProfile) => void;
  trackClick?: (sectionName: string) => void;
}

export const EditableSettingsSection: FC<IEditableSettingsSectionProps> = ({
  isAdmin,
  isManager,
  isOwner,
  record,
  onUpdate,
  trackClick,
}) => {
  const { contextCompany } = useContext(UserContext);
  return !record.companyRole || isManager || isAdmin ? (
    <Section borderRadius padding={["lg"]}>
      <EditableSection
        onEditClick={() => trackClick?.("Searchable consultant profile")}
        editable={(isAdmin && !isOwner) || !contextCompany}>
        {editableProps => (
          <SettingsSection
            editableProps={editableProps}
            record={record}
            onUpdate={onUpdate}
            isAdmin={isAdmin}
            isManager={isManager}
            isOwner={isOwner}
          />
        )}
      </EditableSection>
    </Section>
  ) : null;
};
